import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { useNavigate } from "react-router-dom";
import cardGpg from "../../assets/images/svg/cardGpg.svg";
import cardGpgVertical from "../../assets/images/svg/cardGpgVertical.svg";
import cordaVerticalUrso from "../../assets/images/svg/cordaVerticalUrso.svg";
import "swiper/css";
import "swiper/css/pagination";
import "./index.css";
import Reviews from "./Reviews";
export default function CardGps() {
  const navigate = useNavigate();

  return (
    <div className="card-gps-container">
      <div className="container pt-5 ">
        <div className="d-none d-md-block" style={{ position: "relative" }}>
          <img
            src={cordaVerticalUrso}
            alt="cordaVerticalUrso"
            className="vertical-rope"
          />
          <img
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              zIndex: 20,
            }}
            src={cardGpg}
            alt="Clawz Entertainment Location Map - Find Your Nearest Store"
          />

          <div
            style={{
              zIndex: 30,
              position: "absolute",
              top: "38%",
              left: "57%",
              width: "35%",
              height: "37%",
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592.4476072976385!2d-80.3660572!3d25.7868415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b96f507f5491:0xf74547725046a0ce!2sAdventure+Kids+USA+at+Miami+International+Mall!5e0!3m2!1sen!2sus!4v1708561128403!5m2!1sen!2sus&zoom=18"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: "15px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Clawz Entertainment Location at Miami International Mall"
              aria-label="Interactive map showing Clawz Entertainment location at Miami International Mall"
              role="application"
            />
          </div>
        </div>

        <div className="d-md-none d-block">
          <div style={{ position: "relative" }}>
            <img
              src={cordaVerticalUrso}
              alt="cordaVerticalUrso"
              className="vertical-rope-vertical"
            />
            <img
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                zIndex: 20,
              }}
              src={cardGpgVertical}
              alt="Clawz Entertainment Location Map - Mobile View"
            />

            <div
              style={{
                zIndex: 30,
                position: "absolute",
                top: "55%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "70%",
                height: "20%",
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592.4476072976385!2d-80.3660572!3d25.7868415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b96f507f5491:0xf74547725046a0ce!2sAdventure+Kids+USA+at+Miami+International+Mall!5e0!3m2!1sen!2sus!4v1708561128403!5m2!1sen!2sus&zoom=18"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: "15px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 1000 }}>
          <Reviews />
        </div>
      </div>
    </div>
  );
}
